/**
 * 点位采集实体
 * zxw
 * 2025-05-20
*/

import { useEffect, useState } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    DatePicker,
    Select,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff } from '../../incs/FunHelper';

import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dateLocale from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';

var date = new Date();
var month = date.getMonth() + 1;
var strDate = date.getDate();
if (month >= 1 && month <= 9) {
    month = '0' + month;
}
if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate;
}
const CURRENTDATE = date.getFullYear() + '-' + month + '-' + strDate;

const MODULENAME = '点位采集';
const { TextArea } = Input;
const Option = Select.Option;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [number, setNumber] = useState('');
    const [name, setName] = useState('');
    const [affiliateUnit, setAffiliateUnit] = useState('');
    const [startDate, setStartDate] = useState(CURRENTDATE);
    const [exportTemplate, setExportTemplate] = useState(CNF.pointLocationExportTemplates[0].value);
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (props.record) {
            setNumber(props.record.number);
            setName(props.record.name);
            setAffiliateUnit(props.record.affiliate_unit);
            setStartDate(props.record.start_date);
            setExportTemplate(props.record.export_template);
            setDescription(props.record.description);
        }
    }, [props.record]);

    const cancel = () => {
        setLoading(false);
        props.setOpen(false);
        setName('');
        setNumber('');
        setAffiliateUnit('');
        setStartDate(CURRENTDATE);
        setExportTemplate(CNF.pointLocationExportTemplates[0].value);
        setDescription('');
    };

    const ok = () => {
        //  参数校验
        if (number === '') {
            message.error(MODULENAME + '编码不能为空！', CNF.messageDuration);
            return;
        }
        if (name === '') {
            message.error(MODULENAME + '名称不能为空！', CNF.messageDuration);
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'pointLocation/collects' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'number': number,
                'name': name,
                'affiliate_unit': affiliateUnit,
                'start_date': startDate,
                'export_template': exportTemplate,
                'description': description
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            if (data.status === 422) {
                messageApi.error(data.statusText, CNF.messageDuration);
            } else {
                messageApi.error(data.responseJSON.detail, CNF.messageDuration);
            }
        }).always(function () {
            setTimeout(function () {
                setLoading(false);
            }, CNF.messageDuration * 1000);
        })
    };


    return (
        <>
            {contextHolder}
            <Modal
                width={480}
                title={(props.record ? '修改' : '创建') + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ loading }}
            >
                <Row>
                    <Col span={24}>编号{rff}</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setNumber(e.target.value)}
                            value={number}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>名称{rff}</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>所属单位</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setAffiliateUnit(e.target.value)}
                            value={affiliateUnit}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={10}>开始日期</Col>
                    <Col span={13} offset={1}>下载模版</Col>
                    <Col span={10}>
                        <DatePicker
                            onChange={(_, dateString) => { setStartDate(dateString ? dateString : CURRENTDATE) }}
                            placeholder='请选择日期'
                            value={dayjs(startDate, 'YYYY-MM-DD')}
                            style={{ width: '100%' }}
                            locale={dateLocale}
                            disabled={loading}
                        />
                    </Col>
                    <Col span={13} offset={1}>
                        <Select
                            value={exportTemplate}
                            style={{ width: '100%' }}
                            onChange={(value) => setExportTemplate(value)}
                            disabled={loading}
                        >
                            {
                                CNF.pointLocationExportTemplates && CNF.pointLocationExportTemplates.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder={'备注可写在这里...'}
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default Entity